import axios from 'axios';

/**
 * Wrapper to axios
 */
const request = {
  get: function (url, config) {
    // IE11 fix, prevent browser from caching request
    // Adds a timestamp parameter to the GET request
    if (config) {
      if (config.params) {
        config.params.timestamp = new Date();
      } else {
        config.params = {
          timestamp: new Date()
        };
      }

      return axios.get(url, config);
    } else {
      return axios.get(url, {
        params: {
          timestamp: new Date()
        }
      });
    }
  },
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete
};

export default request;



// WEBPACK FOOTER //
// ./src/common/request.js